var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 10.0196C14.6354 10.3431 10.3428 14.6358 10.0193 20H9.98017C9.65667 14.6358 5.36408 10.3431 0 10.0196V9.98042C5.36408 9.65692 9.65667 5.36433 9.98017 0H10.0193C10.3428 5.36433 14.6354 9.65692 19.9997 9.98042V10.0196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstar);
export default __webpack_public_path__ + "static/media/icon.star.2f89b9bbaf725069d025fc5d16a7bfa1.svg";
export { ForwardRef as ReactComponent };